import { defineMessages } from 'react-intl';

export default defineMessages({
    percentageOffLabel: {
        id: 'QuantityButtons.percentageOff',
        description: 'Label for percentage off',
        defaultMessage: '{percentage}% off',
    },
    hyphenLabel: {
        id: 'QuantityButtons.hyphen',
        description: 'hyphen icon',
        defaultMessage: '-',
    },
    secondItemLabel: {
        id: 'QuantityButtons.secondItemLabel',
        description: 'Label for second item',
        defaultMessage: 'Set of 2',
    },
    individualLabel: {
        id: 'QuantityButtons.individualLabel',
        description: 'Label for individual item',
        defaultMessage: 'Individual',
    },
    quantityLabel: {
        id: 'QuantityButtons.quantityLabel',
        description: 'Label for quantity',
        defaultMessage: 'Quantity:',
    }
    
});


